import React from 'react';
import InfoCard from '../components/InfoCard';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const cardData = [
  {
    icon: 'https://cdn.prod.website-files.com/6589b182968a859c7b60105e/67f2c14e9916bdf9ef5e7a05_rating%20(2).png',
    title: 'Get More Reviews',
    description: 'You can collect customer reviews for your business on platforms like Google Reviews, Trustpilot, and Yelp to enhance credibility and attract more customers.',
  },
  {
    icon: 'https://cdn.prod.website-files.com/6589b182968a859c7b60105e/67f2c14e9916bdf9ef5e79fd_good-feedback%20(1).png',
    title: 'Employee Performance',
    description: 'You can efficiently monitor and evaluate employee performance using real-time data and analytics.',
  },
  {
    icon: 'https://cdn.prod.website-files.com/6589b182968a859c7b60105e/67f2c14e9916bdf9ef5e7a01_choice.png',
    title: 'Surveys',
    description: 'You can create AI-generated surveys to streamline data collection and gain valuable insights for your business.',
  },
  {
    icon: 'https://cdn.prod.website-files.com/6589b182968a859c7b60105e/67f2c14e9916bdf9ef5e79ff_coupon.png',
    title: 'Coupons',
    description: 'You can create exclusive coupons for your customers to encourage repeat business and enhance customer loyalty.',
  },
  {
    icon: 'https://cdn.prod.website-files.com/6589b182968a859c7b60105e/67f2c14e9916bdf9ef5e7a03_referral-bonus.png',
    title: 'Referrals',
    description: 'You can refer your family and friends to our services with confidence. Share the benefits with your loved ones today!',
  },
];

function InfoSection() {
  return (
    <div className="max-w-7xl mx-auto mt-12 px-6 py-10">
      <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {cardData.map((card, index) => {
          const { ref, inView } = useInView({
            triggerOnce: true,
            threshold: 0.3,
          });

          return (
            <motion.div
              key={index}
              ref={ref}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="flex justify-center"
            >
              <InfoCard
                icon={card.icon}
                title={card.title}
                description={card.description}
              />
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}

export default InfoSection;
